import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin/dashboard");
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <main data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-sand px-6">
            <motion.form
                onSubmit={submit}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="w-full max-w-sm border border-line bg-white p-10"
                data-testid="admin-login-form"
            >
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-clay">Maker access</p>
                <h1 className="mt-3 font-serif text-3xl font-light tracking-tight text-gold">Welcome back.</h1>
                <label className="mt-8 block font-mono text-[10px] uppercase tracking-[0.2em] text-clay" htmlFor="admin-email">Email</label>
                <input
                    id="admin-email"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="admin-email-input"
                    className="mt-2 w-full border border-line bg-sand px-4 py-3 text-sm outline-none transition-colors focus:border-espresso"
                />
                <label className="mt-5 block font-mono text-[10px] uppercase tracking-[0.2em] text-clay" htmlFor="admin-password">Password</label>
                <input
                    id="admin-password"
                    type="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    data-testid="admin-password-input"
                    className="mt-2 w-full border border-line bg-sand px-4 py-3 text-sm outline-none transition-colors focus:border-espresso"
                />
                {error && <p className="mt-4 text-sm text-crimson" data-testid="admin-login-error">{error}</p>}
                <button
                    type="submit"
                    disabled={loading}
                    data-testid="admin-login-button"
                    className="mt-8 w-full bg-espresso py-4 font-mono text-xs uppercase tracking-[0.2em] text-sand transition-colors duration-300 hover:bg-crimson disabled:opacity-60"
                >
                    {loading ? "Signing in…" : "Sign in"}
                </button>
                <Link to="/" className="mt-6 block text-center font-mono text-[10px] uppercase tracking-[0.2em] text-clay transition-colors hover:text-crimson">
                    ← Back to the shop
                </Link>
            </motion.form>
        </main>
    );
}
